import React from 'react';
import { Table } from 'lucide-react';
import ReportWidget from './components/ReportWidget';
import { formatDurationHours } from '../../constants/durationUtils';
import { useTranslation } from 'react-i18next';

const StatusDurationWidget = ({ data, loading, error, onDetailsClick }) => {
  const { t } = useTranslation();
  const { summary, workOrders } = data || {};
  const isEmpty = !workOrders || workOrders.length === 0;

  return (
    <ReportWidget
      title={t('reporting.status_duration.title', 'Status Duration Breakdown')}
      loading={loading}
      onDetailsClick={onDetailsClick}
      error={error}
      isEmpty={isEmpty}
      emptyIcon={Table}
      emptyMessage={t('reporting.status_duration.empty', 'No completed work orders with status duration data in the selected period.')}
    >
      {/* Summary Row */}
      {summary && (
        <div className="d-flex flex-wrap justify-content-center gap-4 mb-3 py-2">
          <div className="text-center">
            <div className="fw-bold" style={{ fontSize: '1.1rem' }}>
              {summary.totalCount}
            </div>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>{t('shared.total_wos', 'Total WOs')}</div>
          </div>
          <div className="text-center">
            <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#34d399' }}>
              {formatDurationHours(summary.avgSubmittedHours, { t, compact: true })}
            </div>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>{t('shared.avg_open', 'Avg Open')}</div>
          </div>
          <div className="text-center">
            <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#f59e0b' }}>
              {formatDurationHours(summary.avgPendingHours, { t, compact: true })}
            </div>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>{t('shared.avg_pending', 'Avg Pending')}</div>
          </div>
          <div className="text-center">
            <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#8b5cf6' }}>
              {formatDurationHours(summary.avgInProgressHours, { t, compact: true })}
            </div>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>{t('shared.avg_in_progress', 'Avg In Progress')}</div>
          </div>
          <div className="text-center">
            <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#ef4444' }}>
              {formatDurationHours(summary.avgOnHoldHours, { t, compact: true })}
            </div>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>{t('shared.avg_on_hold', 'Avg On Hold')}</div>
          </div>
          <div className="text-center">
            <div className="fw-bold" style={{ fontSize: '1.1rem' }}>
              {formatDurationHours(summary.avgTotalHours, { t, compact: true })}
            </div>
            <div className="text-muted" style={{ fontSize: '0.7rem' }}>{t('shared.avg_total', 'Avg Total')}</div>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-hover mb-0" style={{ fontSize: '0.85rem' }}>
          <thead>
            <tr className="text-muted">
              <th>{t('shared.ticket', 'Ticket #')}</th>
              <th>{t('shared.title', 'Title')}</th>
              <th style={{ color: '#34d399' }}>{t('shared.open', 'Open')}</th>
              <th style={{ color: '#f59e0b' }}>{t('shared.pending', 'Pending')}</th>
              <th style={{ color: '#8b5cf6' }}>{t('shared.in_progress', 'In Progress')}</th>
              <th style={{ color: '#ef4444' }}>{t('shared.on_hold', 'On Hold')}</th>
              <th>{t('shared.total', 'Total')}</th>
            </tr>
          </thead>
          <tbody>
            {workOrders?.map((wo) => (
              <tr key={wo.id}>
                <td className="fw-medium">{wo.ticketNumber}</td>
                <td className="text-truncate" style={{ maxWidth: '200px' }}>{wo.title}</td>
                <td>{formatDurationHours(wo.submittedHours, { t, compact: true })}</td>
                <td>{formatDurationHours(wo.pendingHours, { t, compact: true })}</td>
                <td>{formatDurationHours(wo.inProgressHours, { t, compact: true })}</td>
                <td>{formatDurationHours(wo.onHoldHours, { t, compact: true })}</td>
                <td className="fw-bold">{formatDurationHours(wo.totalHours, { t, compact: true })}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportWidget>
  );
};

export default StatusDurationWidget;
